<template>
    <div>

        <div class="w-100 d-flex flex-column flex-lg-row position-fixed stat-header align-items-center">
            <div class="flex-grow-1 mr-3 ml-3 mb-1 mb-md-0"><span class="h2">Аналитика и отчёты</span></div>
            <div class="flex-grow-0 d-flex">
                <b-button variant="link" size="md" @click="generatePdf" class="p-0 mr-3">
                    <b-icon icon="file-earmark-pdf" class="mr-1"/>
                    <slot name="title">
                        <span>PDF</span>
                    </slot>
                </b-button>
                <b-button variant="link" size="md" @click="showExcelStats()" class="p-0 mr-3">
                    <b-icon icon="file-earmark-excel" class="mr-1"/>
                    <slot name="title">
                        <span>Excel</span>
                    </slot>
                </b-button>
            </div>
        </div>

        <div class="col-12 d-flex flex-column flex-lg-row p-0 mb-5 pt-4">

            <div id="event-filters" class="position-sticky p-0 col-xs-12 col-lg-3 col-xxl-2 mb-3 mb-lg-0  pr-lg-3 stat-filter " >
                <div class="d-flex flex-column position-sticky stat-filter p-3 pb-4 pb-lg-0 pt-4 pt-lg-3 ">
                    <div class="d-flex align-items-start">
                        <span class="h5 mr-3">Фильтры для отчётов по мероприятиям</span>
                        <b-button variant="outline" class="p-0 flex-grow-0" v-b-toggle="'event-filters-collapse'" >
                            <b-icon class="toggleUpDown" icon="chevron-down" variant="secondary" scale="1" />
                        </b-button>
                    </div>
                    <b-collapse id="event-filters-collapse" visible>
                        <div class="clearfix p-2"></div>
                        <div class="d-flex flex-grow-1 flex-column">
                            <div class="col-xs-12 m-0 p-0 mb-lg-3">
                                <div class="d-flex flex-column mr-0 mb-3 mb-lg-0">
                                        <div class="d-flex mr-3 mb-2 flex-grow-1">
                                            <label for="isEventCountCumulative" class="text-secondary mb-0 mr-2"><small>Нарастающий итог</small></label>
                                            <b-form-checkbox name="isEventCountCumulative" switch v-model="isEventCountCumulative" @change="onIsEventCountCumulativeChange"/>
                                        </div>
                                </div>
                            </div>
                            <div class="col-xs-12 m-0 p-0 mb-3">
                                <div class="d-flex flex-column">
                                    <div class="d-flex flex-column mb-3">
                                        <b-form-radio name="periodFilterType" v-model="periodFilterType" @change="onPeriodFilterTypeChange" value="1" class="mb-1">Год и месяц</b-form-radio>
                                        <div v-if="periodFilterType === '1'" class="d-flex flex-grow-1 flex-row flex-lg-column pl-4">
                                            <div class="d-flex flex-grow-1 flex-column mr-3 mr-lg-0 mb-2">
                                                <single-select v-if="periodFilterType === '1'"
                                                               name="year"
                                                               ref="year"
                                                               class="flex-grow-1 "
                                                               v-model="year"
                                                               :clearable="true"
                                                               :placeholder="'Год'"
                                                               :initial-data="yearOptions()"
                                                               v-on:select-changed="onYearChanged"
                                                               v-on:select-cleared="onYearChanged" />

                                            </div>
                                            <div class="d-flex flex-grow-1 flex-column mb-2">
                                                <single-select v-if="periodFilterType === '1' && year['id']"
                                                               name="month"
                                                               ref="month"
                                                               class="flex-grow-1"
                                                               v-model="month"
                                                               :clearable="true"
                                                               :placeholder="'Месяц'"
                                                               :initial-data="monthOptions()"
                                                               v-on:select-changed="onMonthChanged"
                                                               v-on:select-cleared="onMonthChanged"/>
                                            </div>
                                        </div>
                                        <div v-else class="d-flex flex-grow-1 flex-row pl-4">
                                            <span v-if="month.name" class="text-secondary mr-1 ">{{ month.name }}</span>
                                            <span class="text-secondary">{{ year.name }}</span>
                                        </div>
                                    </div>

                                    <div class="d-flex flex-column flex-grow-1">
                                        <b-form-radio class="mb-2" name="periodFilterType" @change="onPeriodFilterTypeChange" v-model="periodFilterType" value="2">Период</b-form-radio>
                                        <div class="d-flex flex-grow-1 flex-row flex-lg-column pl-4">
                                            <div class="d-flex mb-2 flex-grow-1 flex-column mr-3 mr-lg-0">
                                                <div class="d-flex align-items-center" v-if="periodFilterType === '2'">
                                                    <b-datepicker
                                                        v-model="dateFrom"
                                                        :placeholder="''"
                                                        locale="ru-RU"
                                                        :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit'}"
                                                        :label-help="null"
                                                        @input="onDateFromChanged"
                                                        reset-button
                                                        :label-reset-button="'Сбросить'"
                                                        :max="maxDate"
                                                        class="w-100">
                                                        <template #button-content><small class="text-secondary">с</small></template>
                                                    </b-datepicker>
                                                </div>
                                                <span v-else class="text-secondary">c {{ getDisplayDate(dateFrom) }}</span>
                                            </div>
                                            <div class="d-flex mb-2 flex-grow-1 flex-column">
                                                <div class="d-flex align-items-center" v-if="periodFilterType === '2'">
                                                    <b-datepicker
                                                        v-model="dateTo"
                                                        :placeholder="''"
                                                        locale="ru-RU"
                                                        :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit'}"
                                                        :label-help="null"
                                                        @input="onDateToChanged"
                                                        reset-button
                                                        :label-reset-button="'Сбросить'"
                                                        :max="maxDate">
                                                        <template #button-content><small class="text-secondary">по</small></template>
                                                    </b-datepicker>
                                                </div>
                                                <span v-else class="text-secondary">по {{ getDisplayDate(dateTo) }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 m-0 p-0">
                                <div class="d-flex flex-column mr-0 mb-0">

                                <div v-if="canSelectMunicipality()" class="d-flex mb-2 flex-column flex-grow-1">
<!--                                    <label for="dateTo" class="text-secondary mb-0 mr-2"><small>Муниципалитет</small></label>-->
                                        <single-select name="municipality"
                                                       ref="municipality"
                                                       class="flex-grow-1 mr-2 mr-lg-0"
                                                       v-model="municipality"
                                                       :url="municipalityUrl"
                                                       :initial-filters="municipalityInitialFilters()"
                                                       :placeholder="'Муниципалитет'"
                                                       label-key="short_name"
                                                       :has-pagination="true"
                                                       :clearable="true"
                                                       v-on:select-changed="onMunicipalityChanged"
                                                       v-on:select-cleared="onMunicipalityChanged" />
                                </div>

                                <div v-if="canSelectContractor()" class="d-flex mb-2 flex-column flex-grow-1">
<!--                                    <label for="executor" class="text-secondary mb-0 mr-2"><small>Исполнитель</small></label>-->
                                        <single-select name="executor"
                                                       ref="executor"
                                                       class="flex-grow-1 mr-2 mr-lg-0"
                                                       v-model="executor"
                                                       :url="organizationsUrl"
                                                       label-key="name"
                                                       :has-pagination="true"
                                                       :clearable="true"
                                                       :placeholder="'Исполнитель'"
                                                       :initial-filters="getExecutorInitialFilters"
                                                       v-on:select-changed="onExecutorChanged"
                                                       v-on:select-cleared="onExecutorChanged"/>
                                </div>
                            </div>
                            </div>
                        </div>
                    </b-collapse>
                </div>
            </div>

            <div class="d-flex flex-column col-xs-12 col-lg-9 col-xxl-10 p-0">
                <event-statistics id="eventStats" ref="eventStats" class="stat-wrapper" :common-query-params="eventQueryParams" @breakdown-changed="onEventStatisticsBreakdownChanged"/>
                <euthanasia-statistics id="euthanasiaStats" ref="euthanasiaStats" class="stat-wrapper" @breakdown-changed="onEuthanasiaStatisticsBreakdownChanged" :common-query-params="eventQueryParams"/>
            </div>

        </div>


        <div class="col-12 d-flex flex-column flex-lg-row p-0 mb-5">

            <div id="keeping-filters" class="position-sticky p-0 col-xs-12 col-lg-3 col-xxl-2 mb-3 mb-lg-0  pr-lg-3 stat-filter bg-white">
                <div class="d-flex flex-column  position-sticky stat-filter p-3 pb-4 pb-lg-0 pt-4 pt-lg-3">
                    <div class="d-flex align-items-start">
                        <span class="h5 mr-3">Фильтры для отчётов по содержанию</span>
                        <b-button variant="outline" class="p-0 flex-grow-0" v-b-toggle="'keeping-filters-collapse'" >
                            <b-icon class="toggleUpDown" icon="chevron-down" variant="secondary" scale="1" />
                        </b-button>
                    </div>
                    <b-collapse id="keeping-filters-collapse" visible>
                        <div class="clearfix p-3"></div>
                        <div class="d-flex w-100 flex-column ">
                        <div class="col-xs-12 col-lg-6 m-0 p-0">
                            <div class="d-flex flex-column mr-0 mr-lg-5 mb-lg-0">
                                <div class="d-flex flex-grow-1 flex-wrap">
                                    <div class="d-flex mr-3 mb-2 flex-grow-1 flex-column">
                                        <label for="dateFrom" class="text-secondary mb-0 mr-2 text-nowrap"><small>Состояние на дату</small></label>
                                        <b-datepicker
                                            v-model="datePoint"
                                            :placeholder="''"
                                            locale="ru-RU"
                                            :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit'}"
                                            @input="onDatePointChanged"
                                            style="min-width: 200px"/>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                    </b-collapse>

                </div>
            </div>

            <div class="d-flex flex-column col-xs-12 col-lg-9 col-xxl-10 p-0">
                <keeping-statistics id="keepingStats" ref="keepingStats" class="stat-wrapper" :common-query-params="keepingQueryParams" @breakdown-changed="onKeepingStatisticsBreakdownChanged"/>
                <municipal-keeping-statistics id="munKeepingStats" ref="munKeepingStats" class="stat-wrapper" :common-query-params="keepingQueryParams" @breakdown-changed="onMunKeepingStatisticsBreakdownChanged"/>
            </div>
        </div>

        <b-modal id="excel-stats" centered hide-footer title="Отчёты Excel" size="lg">

            <template #default>
                <div class="d-flex flex-column">
                    <div v-if="currentXlsxReports.length" class="mb-4">
                        <div v-for="(report, i) in currentXlsxReports" class="mb-3">
                            <div v-if="i === 0" class="h5 mb-3">Последний сформированный</div>
                            <div v-if="i === 1" class="text-secondary mb-3">Более ранние</div>
                            <div class="d-flex" :class="{'border-bottom pb-3': i === 0}">
                                <div class="mr-3" v-b-tooltip="getReportStatusName(report)">
                                    <b-spinner v-if="report['status'] === 1" variant="secondary" small />
                                    <b-icon v-else-if="report['status'] === 2" icon="check" variant="success" scale="2"/>
                                    <b-icon scale="2" v-else-if="report['status'] === 3" icon="x" variant="danger" />
                                </div>
                                <div class="d-flex flex-column" v-if="report['report_file']">
                                    <div class="text-secondary"><small>{{ report['created_at'] }}</small></div>
                                    <div><a href="#" @click.prevent.stop="downloadReport(report)">{{ report['report_file']['name'] }}</a></div>
                                    <div  v-if="report['description']">
                                        <div v-if="i === 0" >
                                            <div class="text-secondary"><small v-html="report['description']"></small></div>
                                        </div>
                                        <div v-else>
                                            <b-button v-b-toggle="'stat-description-' + i" variant="link" class="p-0">
                                                <small class="when-open">Свернуть описание</small>
                                                <small class="when-closed">Показать описание</small>
                                            </b-button>
                                            <b-collapse :id="'stat-description-' + i">
                                                <div class="text-secondary"><small v-html="report['description']"></small></div>
                                            </b-collapse>
                                        </div>
                                    </div>
                                </div>
                                <div v-else-if="report['status'] === 1">
                                    <div class="text-secondary"><small>{{ report['created_at'] }}</small></div>
                                    <div>Формируется...</div>
                                </div>
                                <div v-else>
                                    <div class="text-secondary"><small>{{ report['created_at'] }}</small></div>
                                    <div>Ошибка при формировании</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3" v-else>
                        <span>Отчёты не найдены</span>
                    </div>
                    <div>
                        <b-button variant="primary" size="md" @click="createXlsx()">
                            <b-icon icon="file-earmark-excel" class="mr-1"/>
                            <slot name="title">
                                <span>Сгенерировать новый отчет</span>
                            </slot>
                        </b-button>
                    </div>
                </div>
            </template>

            <template #modal-footer>
                <b-button variant="secondary" @click="stay">Закрыть</b-button>
            </template>

        </b-modal>

    </div>
</template>

<script>
import EventStatistics from "@/pages/Statistics/EventStatistics.vue";
import api from "@/api";
import {ACTIVITIES} from "@/store/auth/auth";
import SingleSelect from "@/components/Select/SingleSelect.vue";
import EuthanasiaStatistics from "@/pages/Statistics/EuthanasiaStatistics.vue";
import KeepingStatistics from "@/pages/Statistics/KeepingStatistics.vue";
import MunicipalKeepingStatistics from "@/pages/Statistics/MunicipalKeepingStatistics.vue";
import {mapGetters} from "vuex";
// import { jsPDF } from "jspdf";

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import httpClient from "@/http";
import {download} from "@/components/Files/download";
pdfMake.addVirtualFileSystem(pdfFonts);


export default {
    name: "Statistics",
    components: {MunicipalKeepingStatistics, KeepingStatistics, EuthanasiaStatistics, SingleSelect, EventStatistics},
    data() {
        const today = new Date();
        const month = today.getMonth();
        const year = today.getFullYear();
        return {
            startYear: 2020,
            year: { id: year, name: year },
            month: {  },
            dateFrom: new Date(year, month, 1).toISOString().split('T')[0],
            dateTo: new Date().toISOString().split('T')[0],
            datePoint: new Date().toISOString().split('T')[0],
            municipality: {},
            executor: {},
            usePeriodFilters: false,
            periodFilterType: '1',
            isEventCountCumulative: true,
            eventQueryParams: {},
            keepingQueryParams: {},
            initialMunicipalities: [],
            municipalitySelectable: true,
            executorSelectable: true,
            maxDate: today,
            currentXlsxReports: [],
            currentXlsxReportsLoading: false,
            currentXlsxReportsTimer: null
        }
    },
    computed: {
        ...mapGetters(['isInContractor', 'isMunicipalController', 'isInController',
            'hasMunicipalityRestrictions', 'userOrganizationMunicipalities', 'isVetControl']),
        municipalityUrl() {
            return api.municipalities.default.list()
        },
        organizationsUrl() {
            return api.events.contractors.list();
        },
        getExecutorInitialFilters() {
            return [{ key: 'activities', value: ACTIVITIES.CATCHING }]
        },
    },
    methods: {
        download,
        municipalityInitialFilters() {
            let filters = [];
            for (const m of this.initialMunicipalities) {
                filters.push({ key: 'mun_id', value: m })
            }
            return filters
        },
        canSelectContractor() {
            return (this.isMunicipalController || this.isInController || this.isVetControl) && this.executorSelectable
        },
        canSelectMunicipality() {
            return (this.isInController || this.hasMunicipalityRestrictions && this.userOrganizationMunicipalities.length > 1 || this.isVetControl) && this.municipalitySelectable
        },
        transformDate(value) {
            if (value && typeof value === 'string') {
                const dateParts = value.split('-')
                const dateObject = [dateParts[2], dateParts[1], dateParts[0]];
                return dateObject.join('.');
            }
            if (value) {
                return value.toLocaleDateString()
            }
            return null
        },
        getDisplayDate(value) {
            const date = new Date(value)
            return date.toLocaleString('ru-RU', {year: 'numeric', month: 'long', day: '2-digit'})
        },
        yearOptions() {
            const today = new Date();
            let years = []
            for (let i = this.startYear; i <= today.getFullYear(); i++) {
                years.push({id: i, name: i})
            }
            return years
        },
        monthOptions() {
            let months = []
            for (let i = 0; i < 12; i++) {
                months.push({id: i + 1, name: new Date(0, i).toLocaleString('ru-RU', {month: 'long'})})
            }
            return months
        },
        onYearChanged() {
            this.fetchEventStatistics()
        },
        onMonthChanged() {
            this.fetchEventStatistics()
        },
        onDateFromChanged(value) {
            this.fetchEventStatistics()
        },
        onDateToChanged(value) {
            this.fetchEventStatistics()
        },
        onMunicipalityChanged(name, item) {
            this.municipality = item
            this.fetchEventStatistics()
        },
        onExecutorChanged(name, item) {
            this.executor = item
            this.fetchEventStatistics()
        },
        onPeriodFilterTypeChange() {
            this.fetchEventStatistics()
        },
        onIsEventCountCumulativeChange() {
            this.fetchEventStatistics()
        },
        onDatePointChanged(value) {
            this.fetchKeepingStatistics()
        },
        async gatherEventQueryParams() {
            this.eventQueryParams = {}
            if (this.periodFilterType === '2') {
                this.eventQueryParams['execution_date_from'] = this.transformDate(this.dateFrom)
                this.eventQueryParams['execution_date_to'] = this.transformDate(this.dateTo)
            } else {
                this.eventQueryParams['execution_year'] = this.year.id
                this.eventQueryParams['execution_month'] = this.month.id
            }
            if (this.municipality && this.municipality.id) {
                this.eventQueryParams['municipality'] = this.municipality['id']
                this.eventQueryParams['municipality_name'] = this.municipality['short_name']
            }
            if (this.executor && this.executor.id) {
                this.eventQueryParams['executor'] = this.executor['id']
                this.eventQueryParams['executor_name'] = this.executor['name']
            }
            if (this.isEventCountCumulative) {
                this.eventQueryParams['cumulative'] = true
            }
        },
        async fetchEventStatistics() {
            await this.gatherEventQueryParams();
            await this.$nextTick();
            await this.$refs.eventStats.fetch();
            await this.$refs.euthanasiaStats.fetch();
        },

        async gatherKeepingQueryParams() {
            this.keepingQueryParams = {}
            this.keepingQueryParams['date'] = this.transformDate(this.datePoint);
        },
        async fetchKeepingStatistics() {
            await this.gatherKeepingQueryParams();
            await this.$nextTick()
            await this.$refs.keepingStats.fetch();
            await this.$refs.munKeepingStats.fetch();
        },
        async onEventStatisticsBreakdownChanged(value) {
            const v = parseInt(value);
            if (v === 1) {
                this.municipality = {};
                this.executor = {};
                this.municipalitySelectable = true;
                this.executorSelectable = true;
            }
            if (v === 2) {
                this.municipality = {};
                this.executor = {};
                this.municipalitySelectable = false;
                this.executorSelectable = true;
            }
            if (v === 3) {
                this.municipality = {};
                this.executor = {};
                this.municipalitySelectable = true;
                this.executorSelectable = false;
            }
            await this.gatherEventQueryParams();
            await this.$nextTick();
            await this.$refs.eventStats.fetch();
        },
        async onEuthanasiaStatisticsBreakdownChanged(value){
            const v = parseInt(value);
            if (v === 1) {
                this.municipality = {};
                this.executor = {};
                this.municipalitySelectable = true;
                this.executorSelectable = true;
            }
            if (v === 2) {
                this.municipality = {};
                this.executor = {};
                this.municipalitySelectable = false;
                this.executorSelectable = true;
            }
            if (v === 3) {
                this.municipality = {};
                this.executor = {};
                this.municipalitySelectable = true;
                this.executorSelectable = false;
            }
            await this.gatherEventQueryParams();
            await this.$nextTick();
            await this.$refs.euthanasiaStats.fetch();
        },
        async onKeepingStatisticsBreakdownChanged() {
            await this.gatherKeepingQueryParams();
            await this.$nextTick()
            await this.$refs.keepingStats.fetch();
        },
        async onMunKeepingStatisticsBreakdownChanged() {
            await this.gatherKeepingQueryParams();
            await this.$nextTick()
            await this.$refs.munKeepingStats.fetch();
        },
        generatePdf() {
            const vm = this;
            let index = 0;
            const secondaryColor = '#777';
            const nowDateParts = new Date().toISOString().split('T')
            const fileName = `Аналитика_АИС_Животные_${nowDateParts[0]}_${nowDateParts[1].split('.')[0]}.pdf`;
            let docDefinition = {
                header: { text: fileName, alignment: 'center', fontSize: 8, color: secondaryColor, margin: [30, 10] },
                footer: function(currentPage, pageCount) { return { text: currentPage.toString() + ' из ' + pageCount, alignment: 'center'} },
                info: {
                    title: fileName
                },
                pageSize: 'A4',
                pageOrientation: 'portrait',
                pageMargins: [ 50, 30, 40, 20 ],
                content: []
            };
            pdfMake.tableLayouts = {
                tableLayout: {
                    hLineWidth: function (i) {
                        return .5;
                    },
                    vLineWidth: function (i) {
                        return .5;
                    },
                    hLineColor: function (i) {
                        return '#bbb';
                    },
                    vLineColor: function (i) {
                        return '#bbb';
                    },
                    fillColor: function(i, node) { return i === 0 ? '#ddd' : null; },
                }
            }

            function _addChart(statWrapper) {
                const chartContainer = statWrapper.querySelector(".offscreen-chart");
                // if (!chartContainer) { return }
                const title = chartContainer.querySelector('.offscreen-chart-title')
                const subtitle = chartContainer.querySelector('.offscreen-chart-subtitle')
                const chart = chartContainer.querySelector('canvas');
                const table = statWrapper.querySelector('.stat-table');

                let imgData = null;
                if (chart) {
                    imgData = chart.toDataURL('image/png');
                }

                let imageDefinition = null;
                if (imgData) {
                    imageDefinition = {image: imgData, fit: [520, 320], alignment: 'center'}
                }
                let titleDefinition = {text: title.textContent, fontSize: 18, alignment: 'center' }
                docDefinition.content.push(titleDefinition);
                if (subtitle) {
                    docDefinition.content.push({text: subtitle.textContent, fontSize: 10, alignment: 'center',  color: secondaryColor});
                }
                docDefinition.content.push({text: '', marginBottom: 10});
                if (imageDefinition) {
                    docDefinition.content.push(imageDefinition);
                } else {
                    docDefinition.content.push({text: 'Данных нет', alignment: 'center'});
                }

                if (table) {
                    const tableVisible = table.classList.contains('stats-pdf-visible');
                    if (!tableVisible) {
                        docDefinition.content.push({text: '', marginBottom: 30});
                        return
                    }

                    let tablesCount = 1;
                    const maxCellCount = Math.min(7, table.rows[0].cells.length);
                    if (table.rows[0].cells.length > maxCellCount) {
                        tablesCount += Math.ceil(table.rows[0].cells.length / maxCellCount);
                    }
                    docDefinition.content.push({text: '', marginBottom: 20});

                    let offset = 0;
                    for (let k = 0; k < tablesCount; k++) {
                        let offsetDelta = 0;
                        let tableDefinition = {layout: 'tableLayout', table: {headerRows: 1, widths: [], body: []}}
                        for (let i = 0; i < table.rows.length; i++) {
                            let row = [];
                            for (let j = 0; j < Math.min(maxCellCount - offsetDelta, table.rows[0].cells.length - offset); j++) {  //table.rows[i].cells.length
                                if (j !== 0) {
                                    tableDefinition.table.widths.push(45)
                                } else {
                                    tableDefinition.table.widths.push(170)
                                }
                                if (k >= 1 && j === 0) {
                                    row.push({text: table.rows[i].cells[0].textContent, fontSize: 10})
                                    tableDefinition.table.widths.push(45)
                                    offsetDelta = 1;
                                }
                                let rowDefinition = {text: table.rows[i].cells[j + offset].textContent, fontSize: 10};
                                if (j > 0 || k >= 1 && j === 0) {
                                    rowDefinition['alignment'] = 'center'
                                }
                                row.push(rowDefinition)
                            }
                            tableDefinition.table.body.push(row);
                        }
                        offset += maxCellCount - offsetDelta
                        docDefinition.content.push(tableDefinition);
                    }

                    docDefinition.content.push({text: '', marginBottom: 30});
                    docDefinition.content.push({text: '', pageBreak: 'before'});
                }

                index++;

            }

            const statWrappers = document.querySelectorAll(".stat-wrapper");
            let ready = true;
            try {
                statWrappers.forEach( (statWrapper) => {
                    _addChart(statWrapper)
                });
            } catch (reason) {
                ready = false
                vm.$bvToast.toast('Графики формируются, подождите', {title: 'Выгрузка отчёта', autoHideDelay: 5000, variant: 'warning'})
            }

            if (ready) {
                pdfMake.createPdf(docDefinition).download(fileName);
            }

        },

        async createXlsx() {
            await this.gatherEventQueryParams();
            let eventStatsExtraParams = {
                'all': {
                    'data': this.$refs.eventStats.getExtraParams(),
                    'breakdown': this.$refs.eventStats.getBreakdownType()
                },
                'euthanasia': {
                    'data': this.$refs.euthanasiaStats.getExtraParams(),
                    'breakdown': this.$refs.euthanasiaStats.getBreakdownType()
                }
            }
            let eventQueryParams = {'common': this.eventQueryParams}
            Object.assign(eventQueryParams, {'counts': eventStatsExtraParams})

            await this.gatherKeepingQueryParams();
            let keepingStatsExtraParams = {
                'keeping': {
                    'data': this.$refs.keepingStats.getExtraParams(),
                    'breakdown': this.$refs.keepingStats.getBreakdownType()
                },
                'mun': {
                    'data': this.$refs.munKeepingStats.getExtraParams(),
                    'breakdown': this.$refs.munKeepingStats.getBreakdownType()
                }
            }
            let keepingQueryParams = {'common': this.keepingQueryParams}
            Object.assign(keepingQueryParams, {'keeping': keepingStatsExtraParams})

            let data = {
                'events': eventQueryParams,
                'animals': keepingQueryParams
            }

            const response = await httpClient.post(api.statistics.default.list(), data);
            const newReport = response.data
            this.currentXlsxReports.unshift(newReport)

            const vm = this;
            function _refreshExcelStats() {
                vm.currentXlsxReports = [];
                vm.currentXlsxReportsLoading = true
                vm.getCurrentXlsx().then((response) => {
                    vm.currentXlsxReports = response.data['report_id'];
                }).finally(() => {
                    vm.currentXlsxReportsLoading = false;
                })
            }

            this.currentXlsxReportsTimer = setTimeout(_refreshExcelStats, 10000)
        },

        getCurrentXlsx() {
            return httpClient.get(api.statistics.default.list())
        },

        showExcelStats() {
            const vm = this;
            vm.currentXlsxReportsLoading = true
            vm.getCurrentXlsx().then((response) => {
                vm.$bvModal.show('excel-stats');
                vm.currentXlsxReports = response.data['report_id']
            }).finally(() => {
                vm.currentXlsxReportsLoading = false
            })
        },

        getReportStatusName(report) {
            switch(report['status']) {
                case 1:
                    return 'Формируется'
                case 2:
                    return 'Сформирован'
                case 3:
                    return 'Ошибка формирования'
            }
        },

        downloadReport(report) {
            download(api.statistics.download.list(api.statistics.default.detail(report['id'])))
        }
    },
    beforeMount() {
        if (this.hasMunicipalityRestrictions) {
            this.initialMunicipalities = this.userOrganizationMunicipalities
        }
    },
    async mounted() {
        await this.fetchEventStatistics();
        await this.fetchKeepingStatistics();
    }
}
</script>

<style scoped lang="scss">

    @import "node_modules/bootstrap/scss/functions";
    @import "node_modules/bootstrap/scss/variables";

    .collapsed > .when-open,
    .not-collapsed > .when-closed {
      display: none;
    }

    .stat-header {
        top: 70px;
        height: 100px;
        z-index: 1001;
        background-color: white;
        align-items: center;
        margin-left: -15px;
        padding: 15px;
        border-bottom: 1px solid #ddd;
        margin-bottom: 30px;
        scrollbar-gutter: stable both-edges;
        //max-width: 100%;
        //max-width: 320px;
    }

    .stat-filter {
        top: 170px;
        z-index: 999;
        background-color: white;
        //max-width: 320px;
    }

    //@media screen and (min-width: 1200px) and (max-width: 1490px) {
    //    min-width: 320px;
    //}

    @media screen and (max-width: 991px) {
        .stat-filter {
            top: 180px;
            z-index: 999;
        }

        .stat-header {
            top: 90px;
            z-index: 1001;
            height: 100px;
        }


        #event-filters, #keeping-filters {
            border: 1px solid rgba(0, 0, 0, 0.125);
            border-radius: 0.25rem;
            box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important
        }
    }


</style>